import { render, staticRenderFns } from "./StandalonePolicyQuestions.vue?vue&type=template&id=351012ba"
import script from "./StandalonePolicyQuestions.vue?vue&type=script&lang=js"
export * from "./StandalonePolicyQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports